import React from 'react';
import { Link } from 'react-router-dom';

const LoginChoice = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white shadow-md rounded-lg p-6 space-y-6">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">Choose Login</h1>
          <p className="text-sm text-gray-600 mt-1">
            Select which area you want to access.
          </p>
        </div>

        <div className="space-y-3">
          <Link
            to="/sysadmin/login"
            className="block w-full text-center rounded-md bg-gray-900 px-4 py-2.5 font-medium text-white hover:bg-black"
          >
            SysAdmin Login
          </Link>

          <Link
            to="/radius/login"
            className="block w-full text-center rounded-md bg-indigo-600 px-4 py-2.5 font-medium text-white hover:bg-indigo-700"
          >
            Radius Login
          </Link>
        </div>

        <p className="text-xs text-gray-500">
          Not sure? If you manage the system, choose <span className="font-medium">SysAdmin</span>.
          If you’re a network user, choose <span className="font-medium">Radius</span>.
        </p>
      </div>
    </div>
  );
};

export default LoginChoice;
